// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"TipoExame_checkbox__2U0y-","icone":"TipoExame_icone__2mojU","foco":"TipoExame_foco__3SrF2"};